import React, { useEffect, useState } from "react";
import { getRubros, postRubro, putRubro } from "../../componentes/http/actions/RubroAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import NuevoRubroModal from "../../componentes/modal/Rubros/NuevoRubroModal";
import EditarRubroModal from "../../componentes/modal/Rubros/EditarRubroModal";
import FilterComponent from "../../componentes/data/FilterComponent";
const GestorRubros = () => {
  const [rubros, setRubros] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [rubroSeleccionado, setRubroSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  useEffect(() => {
    fetchRubros();
  }, []);

  const fetchRubros = () => {
    setIsLoading(true);
    getRubros(localStorage.getItem("token"))
      .then((response) => {
        setRubros(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredRubros = rubros
    .filter((rubro) => {
      const matchesSearch = rubro.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && rubro.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          rubro.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  //Modal de nuevo rubro
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //Modal de editar rubro
  const handleOpenEditModal = (rubro) => {
    setRubroSeleccionado(rubro);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setRubroSeleccionado(null);
  };

  const handleNuevoRubro = async (rubro) => {
    try {
      setIsLoading(true);
      await postRubro(localStorage.getItem("token"), rubro);
      await fetchRubros();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Rubro agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo rubro:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar rubro: rubro ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditarRubro = async (rubro) => {
    try {
      setIsLoading(true);
      await putRubro(localStorage.getItem("token"), rubro);
      await fetchRubros();
      setSnackbar({
        open: true,
        message: "Rubro editado con éxito: rubro ya existe o error en el servidor",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar rubro:", error);
      setSnackbar({
        open: true,
        message: "Error al editar rubro",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ 
        width: '100%', 
      }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron rubros con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Rubros</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir rubro
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : rubros.length > 0 ? (
          <>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Habilitado</TableCell>
                <TableCell sx={{ display: "flex", justifyContent: "center" }}>
                  Acciones{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRubros.map((rubros, index) => (
                <TableRow key={index}>
                  <TableCell>{rubros.id}</TableCell>
                  <TableCell>{rubros.nombre}</TableCell>
                  <TableCell>
                    <Chip
                      label={rubros.habilitado ? "Sí" : "No"}
                      color={rubros.habilitado ? "success" : "error"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                      <Tooltip title="Editar rubro">
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => handleOpenEditModal(rubros)}
                      >
                        <EditNoteIcon />
                      </Button>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={
            rubros.filter((rubros) => {
              const matchesSearch = rubros.nombre
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
              const matchesFilter =
                filterHabilitado === "todos" ||
                (filterHabilitado === "habilitado" &&
                  rubros.habilitado === true) ||
                (filterHabilitado === "deshabilitado" &&
                  rubros.habilitado === false);
              return matchesSearch && matchesFilter;
            }).length
          }
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>
      <NuevoRubroModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoRubro}
        isLoading={isLoading}
      />
      <EditarRubroModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarRubro}
        rubros={rubroSeleccionado}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorRubros;
